import * as React from 'react'
import classNames from 'classnames'

export interface Props {
  labelClass?: string
  value: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  selected: boolean
  label: React.ReactNode
  disabled?: boolean
}

const Radio: React.FC<Props> = ({
  value,
  onChange,
  selected,
  label,
  disabled = false,
}): JSX.Element => {
  const labelClass = classNames('radio-label', {
    'u-grey-60': disabled,
  })
  return (
    <label className={labelClass}>
      <span className="radio">
        <input
          type="radio"
          value={value}
          onChange={onChange}
          checked={selected}
          disabled={disabled}
        />
        <span className="radio--value" aria-hidden="true"></span>
      </span>
      {label}
    </label>
  )
}

export default Radio
